import React from 'react';
import DashboardFormSteps from './DashboardFormSteps.js';
import './DashboardNotifications.css';

/** Group outstanding-work notifications in the dashboard's left column. */
export default function DashboardNotifications() {
  return (
    <section className='dashboardNotifications_card' aria-labelledby='dashboard-notifications-title'>
      <h2 id='dashboard-notifications-title' className='dashboard_tabHeaders'>Notifications</h2>
      <DashboardFormSteps />
    </section>
  );
}
